import * as z from "zod";
import { userFacingError } from "../authorization";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

export const deleteOidcProvider = mutator({
  schema: z.object({ id: z.string() }),
  resolve: {
    provider: { kind: "oidcProvider", from: "id" },
  },
  permissions: [
    {
      permission: "tenant:oidc_providers_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
  ],
  fn: async ({ tx, args: { provider } }) => {
    const federations = await tx.run(
      zql.serviceAccountFederations.where("providerId", provider.id)
    );
    if (federations.length > 0) {
      throw userFacingError(
        "This provider is still used by service-account federations. Remove them before deleting it."
      );
    }
    // role_grants.scope_id has no FK to oidc_providers, so provider-scoped
    // grants (e.g. oidc_provider_manager) don't cascade on delete — remove them.
    const scopedGrants = await tx.run(
      zql.roleGrants.where("scopeId", provider.id)
    );
    for (const grant of scopedGrants) {
      await tx.mutate.roleGrants.delete({ id: grant.id });
    }
    await tx.mutate.oidcProviders.delete({ id: provider.id });
  },
});
